var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0095 3.52511L18.9095 6.14511C20.6095 6.89511 20.6095 8.13511 18.9095 8.88511L13.0095 11.5051C12.3395 11.8051 11.2395 11.8051 10.5695 11.5051L4.66953 8.88511C2.96953 8.13511 2.96953 6.89511 4.66953 6.14511L10.5695 3.52511C11.2395 3.22511 12.3395 3.22511 13.0095 3.52511Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.6051C3 12.4451 3.63 13.4151 4.4 13.7551L11.19 16.7751C11.71 17.0051 12.3 17.0051 12.81 16.7751L19.6 13.7551C20.37 13.4151 21 12.4451 21 11.6051",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.6051C3 17.5351 3.55 18.3751 4.4 18.7551L11.19 21.7751C11.71 22.0051 12.3 22.0051 12.81 21.7751L19.6 18.7551C20.45 18.3751 21 17.5351 21 16.6051",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.d3fc37431ef6d68e9945ffd47ab68294.svg";
export { ForwardRef as ReactComponent };